import { FC } from "react";
import { IconPropsType } from ".";

export const PersonalSms: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? "16"}
      height={props.size ?? "16"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8315 8.89189C12.8315 8.17817 13.4101 7.59958 14.1238 7.59958H26.1854C28.8023 7.59958 30.9238 9.72106 30.9238 12.338V23.538C30.9238 26.155 28.8023 28.2765 26.1854 28.2765H10.6777C8.06069 28.2765 5.93921 26.155 5.93921 23.538V21.815C5.93921 21.1012 6.5178 20.5227 7.23152 20.5227C7.94524 20.5227 8.52383 21.1012 8.52383 21.815V23.538C8.52383 24.7276 9.48814 25.6919 10.6777 25.6919H26.1854C27.3749 25.6919 28.3392 24.7276 28.3392 23.538V12.338C28.3392 12.2212 28.3299 12.1064 28.312 11.9946L20.5165 19.0814C19.3255 20.1641 17.4941 20.1205 16.356 18.9824L14.9331 17.5595C14.4284 17.0549 14.4284 16.2366 14.9331 15.7319C15.4378 15.2273 16.256 15.2273 16.7607 15.7319L18.1836 17.1548C18.3462 17.3174 18.6078 17.3236 18.7779 17.1689L26.4442 10.1996C26.3593 10.1894 26.273 10.1842 26.1854 10.1842H14.1238C13.4101 10.1842 12.8315 9.60561 12.8315 8.89189Z"
        fill={props.color ?? "#555555"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.09306 8.03035C8.56887 8.03035 8.9546 7.64462 8.9546 7.16881C8.9546 6.693 8.56887 6.30727 8.09306 6.30727C7.61724 6.30727 7.23152 6.693 7.23152 7.16881C7.23152 7.64462 7.61724 8.03035 8.09306 8.03035ZM8.09306 10.615C9.99632 10.615 11.5392 9.07207 11.5392 7.16881C11.5392 5.26555 9.99632 3.72266 8.09306 3.72266C6.1898 3.72266 4.64691 5.26555 4.64691 7.16881C4.64691 9.07207 6.1898 10.615 8.09306 10.615Z"
        fill={props.color ?? "#555555"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.81614 14.9227H6.36998C5.89417 14.9227 5.50844 15.3084 5.50844 15.7842V16.6457H10.6777V15.7842C10.6777 15.3084 10.292 14.9227 9.81614 14.9227ZM6.36998 12.338C4.46672 12.338 2.92383 13.8809 2.92383 15.7842V17.5073C2.92383 18.4589 3.69528 19.2303 4.64691 19.2303H11.5392C12.4908 19.2303 13.2623 18.4589 13.2623 17.5073V15.7842C13.2623 13.8809 11.7194 12.338 9.81614 12.338H6.36998Z"
        fill={props.color ?? "#555555"}
      />
    </svg>
  );
};
